var map = {
	"./img_1.jpg": 13018,
	"./img_2.jpg": 34330,
	"./img_3.jpg": 45146,
	"./img_4.jpg": 57652,
	"./img_5.jpg": 98729,
	"./img_6.jpg": 86570,
	"./img_7.jpg": 9604,
	"./img_8.jpg": 66996
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82565;